<template>
    <div class="scrollable-list">
        <div class="gallery collection-item-list">
            <GalleryItem v-for="(item, index) in props.items" :id="item" :index="index" :key="item"/>
            <!-- <CollectionIndexItem v-if="links.prev" :key="links.prev.id" :item="links.prev.item"/>
            <CollectionIndexItem v-if="links.next" :key="links.next.id" :item="links.next.item"/> -->
        </div>
    </div>

  <div class="overlay gradient-left"></div>
  <div class="overlay gradient-right"></div>
</template>
<style lang="scss">
.right-zone {
  padding: 1rem 0;
  .scrollable-list{
    //padding: 0 1rem;
    overflow-x: auto;
    overflow-y: hidden;
    height: 100%;
    // .gallery{
    //   margin: 0 1rem;
    // }
  }
  position: relative;
  transform: scale(1,1);
  

  .overlay {
    position:absolute;
    top: 0;
    bottom: 0;
    width: 1rem;
  }

  .gradient-left {
    left: 0;
    background: rgb(255,255,255);
    background: linear-gradient(90deg, rgba(255,255,255,1) 0%, rgba(255,255,255,0) 100%);
  }

  .gradient-right {
    right: 0;
    background: rgb(255,255,255);
    background: linear-gradient(-90deg, rgba(255,255,255,1) 0%, rgba(255,255,255,0) 100%);
  }
}
</style>

<script setup>
import GalleryItem from '@/components/GalleryItem.vue'
// import CollectionIndexItem from './CollectionIndexItem.vue';

// eslint-disable-next-line no-undef
const props = defineProps(['items','links'])

</script>